import styled from '@emotion/styled';
import { Grid } from 'views/anyguide/messages/styles';
import SettingsIcn from 'views/ui/icons/settings-icon';
import { DownArrowIcon } from 'views/ui/icons';
import NavIcn from 'views/ui/icons/ic-nav-chevron-icon';
import { Theme } from 'ui_system/theme';

export const TabList = styled('div')`
  background: ${Theme.colors.backgroundColor};
  border-right: 1px solid #efefef;
  height: 100%;
  position: relative;
  > div:last-of-type {
    /* border-bottom: solid 1px #ccc; */
  }

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    display: ${(props) => (props.mobileTabsMenuToggled ? 'block' : 'none')};
    background: #fff;
    height: auto;
    position: absolute;
    width: 100%;
    z-index: 100;
    /* &:hover {
      box-shadow: 0 1px 3px #999;
    } */
  }
`;

export const Tab = styled(Grid)`
  font-family: 'soleil', Helvetica, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.8rem;
  background-color: ${(props) =>
    props.selected ? '#fff' : Theme.colors.backgroundColor};
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #fff;
  color: #ccc;
  cursor: pointer;
  align-items: end;
  width: 100%;
  text-decoration: none;
  padding: ${(props) =>
    props.reducedPadding ? '8px 10px 17px 19px' : '20px 10px 17px 19px'};
  overflow: hidden;
  height: 80px;
  position: relative;
  svg {
    display: none;
  }

  &:hover {
    background-color: #fff;
    transition: background-color 200ms linear;
    opacity: 1;
  }
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    grid-gap: 0px;
    background: #fff;
    svg {
      display: block;
    }
  }
`;
export const AdvancedTab = styled(Tab)`
  color: ${Theme.colors.linksDesignElementsBaseColor};
  font-size: 1.8rem;
  padding: 20px 20px 17px 18px;
  align-items: center;
  border-bottom: 1px solid #ccc;
  background: ${(props) => (props.selected ? '#fff' : 'inherit')};
  div {
    color: ${Theme.colors.linksDesignElementsBaseColor};
    position: relative;
    top: -4px;
  }
  svg {
    fill: ${Theme.colors.linksDesignElementsBaseColor};
    position: relative;
    top: -4px;
    display: block;
  }

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    grid-template-columns: 35px 1fr 19px;
    /* font-size: 1.4rem; */
    /* padding: 10px 20px 10px 18px; */
  }
`;

export const SubTab = styled('div')`
  padding: 10px 20px;
  font-size: 14px;
  color: ${(props) =>
    props.selected ? '#000' : Theme.colors.primaryTextColor};
  cursor: pointer;
  background-color: ${(props) =>
    props.selected ? '#fff' : Theme.colors.backgroundColor};
  ${(props) => props.bottomBorder && 'border-bottom: solid 1px #ccc'};
  &:hover {
    background: #fff;
  }
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    background-color: #fff;
  }
  /* font-weight: ${(props) => (props.selected ? 'bold' : 'normal')}; */
`;

export const TabTitle = styled('div')`
  font-size: 1.8rem;
  display: block;
  color: ${Theme.colors.primaryTextColor};

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 1.7rem;
  }
`;

export const SubtabTitle = styled('div')`
  font-size: 1.6rem;
  line-height: 1.8rem;
  display: block;
  color: #333;
`;

export const AdvancedSubtabTitle = styled(SubtabTitle)`
  font-size: 17px;
`;

export const TabInfo = styled('div')`
  position: relative;
`;
export const TabSubtitle = styled('div')`
  font-size: 1.4rem;
  line-height: 1.8rem;
  position: relative;
  top: -2px;
  display: block;
  color: ${Theme.colors.secondaryTextColor};
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 1.3rem;
  }
`;

export const TabStatus = styled('span')`
  border: ${(props) =>
    props.completed && props.noborder
      ? 'none'
      : props.completed
        ? props.color
          ? `1px solid${props.color}`
          : `1px solid ${Theme.colors.linksDesignElementsBaseColor}`
        : '1px solid #bbb'};
  border-radius: 100px;
  background-color: ${(props) =>
    props.completed ? '#fff' : Theme.colors.backgroundColor};
  width: 33px;
  height: 32px;
  margin-top: 4px;
  text-align: center;
  position: relative;
  top: -6px;
  svg {
    fill: ${(props) =>
      props.color ? props.color : Theme.colors.linksDesignElementsBaseColor};
    display: block !important;
  }
`;

export const SettingsIcon = styled(SettingsIcn)`
  height: 30px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    height: 22px;
  }
`;

export const ArrowIcon = styled(DownArrowIcon)`
  height: 10px;
  fill: ${Theme.colors.linksDesignElementsBaseColor};
  margin-top: 6px;
  cursor: pointer;
`;

export const NavIcon = styled(NavIcn)`
  height: 12px;
  cursor: pointer;
  right: 11px;
  top: 13px;
  position: absolute;
  &:not(:root) {
    overflow: visible;
  }
`;

export const MobileToggle = styled(ArrowIcon)`
  display: none;
`;

export const AdvancedSettingSubTab = styled.div`
  padding: 10px 20px;
  font-size: 14px;
  color: ${Theme.colors.primaryTextColor};
  cursor: pointer;
  background-color: ${(props) =>
    props.selected ? Theme.colors.white : Theme.colors.backgroundColor};

  &:hover {
    background: ${Theme.colors.white};
  }

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    background-color: ${Theme.colors.white};
    border-bottom: solid 1px ${Theme.colors.lightBorder};
  }
`;

export const AdvancedSettingSubMenu = styled.div`
  font-size: 12px;
  color: ${Theme.colors.lightText};
  padding: 10px;
  cursor: default;

  &:last-child {
    margin-top: 20px;
  }
`;
